// =========================
// Mobile Navigation Toggle
// =========================
const hamburger = document.getElementById('hamburger');
const navLinks = document.getElementById('navLinks');

if (hamburger && navLinks) {
    hamburger.addEventListener('click', () => {
        navLinks.classList.toggle('active');
    });

    // Close menu when a link is clicked
    document.querySelectorAll('.nav-links a').forEach(link => {
        link.addEventListener('click', () => {
            navLinks.classList.remove('active');
        });
    });
}

// =========================
// FAQ Accordion
// =========================
const faqItems = document.querySelectorAll('.faq-item');

faqItems.forEach(item => {
    const question = item.querySelector('.faq-question');
    question.addEventListener('click', () => {
        const isActive = item.classList.contains('active');

        // Close all items
        faqItems.forEach(i => i.classList.remove('active'));

        // Open clicked item if it wasn't already active
        if (!isActive) {
            item.classList.add('active');
        }
    });
});

// =========================
// Navbar Background on Scroll
// =========================
const navbar = document.querySelector('.navbar');

window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
        navbar.style.background = 'rgba(10, 10, 10, 0.95)';
        navbar.style.padding = '14px 0';
        navbar.style.position = 'fixed';
        navbar.style.top = '0';
        navbar.style.left = '0';
        navbar.style.right = '0';
        navbar.style.zIndex = '100';
        navbar.style.padding = '14px 8%';
        navbar.style.backdropFilter = 'blur(10px)';
    } else {
        navbar.style.background = 'transparent';
        navbar.style.position = 'relative';
        navbar.style.padding = '24px 0';
        navbar.style.backdropFilter = 'none';
    }
});

// =========================
// Smooth Reveal on Scroll
// =========================
const observerOptions = {
    threshold: 0.15,
    rootMargin: '0px 0px -50px 0px'
};

const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
        }
    });
}, observerOptions);

document.querySelectorAll('.card, .product-card, .faq-item, .section-title').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(30px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    revealObserver.observe(el);
});

// =========================
// Testimonial Slider
// =========================
const testTrack = document.getElementById('testimonialTrack');
const testPrev = document.getElementById('testPrev');
const testNext = document.getElementById('testNext');
const testDots = document.getElementById('testDots');

if (testTrack && testPrev && testNext) {
    const cards = testTrack.querySelectorAll('.testimonial-card');
    const totalSlides = cards.length;
    let currentSlide = 0;
    let autoplay;

    // Build dots
    cards.forEach((_, i) => {
        const dot = document.createElement('span');
        if (i === 0) dot.classList.add('active');
        dot.addEventListener('click', () => goToSlide(i));
        testDots.appendChild(dot);
    });

    const dots = testDots.querySelectorAll('span');

    function goToSlide(index) {
        currentSlide = (index + totalSlides) % totalSlides;
        testTrack.style.transform = `translateX(-${currentSlide * 100}%)`;
        dots.forEach((d, i) => d.classList.toggle('active', i === currentSlide));
    }

    testNext.addEventListener('click', () => {
        goToSlide(currentSlide + 1);
        resetAutoplay();
    });

    testPrev.addEventListener('click', () => {
        goToSlide(currentSlide - 1);
        resetAutoplay();
    });

    function startAutoplay() {
        autoplay = setInterval(() => goToSlide(currentSlide + 1), 5000);
    }

    function resetAutoplay() {
        clearInterval(autoplay);
        startAutoplay();
    }

    // Pause on hover
    testTrack.addEventListener('mouseenter', () => clearInterval(autoplay));
    testTrack.addEventListener('mouseleave', startAutoplay);

    // Touch swipe support
    let touchStartX = 0;
    testTrack.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    testTrack.addEventListener('touchend', (e) => {
        const touchEndX = e.changedTouches[0].screenX;
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) {
            goToSlide(currentSlide + (diff > 0 ? 1 : -1));
            resetAutoplay();
        }
    }, { passive: true });

    startAutoplay();
}

// =========================
// Newsletter Form
// =========================
function subscribe(event) {
    event.preventDefault();
    const input = event.target.querySelector('input[type="email"]');
    const email = input.value.trim();

    if (email) {
        alert(`Thank you for subscribing with ${email}!`);
        input.value = '';
    }
    return false;
}
